import React from 'react';
import ReactDOM from 'react-dom/client';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from './auth/msalConfig';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const msalInstance = new PublicClientApplication(msalConfig);

const renderApp = () => {
  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
  );
  root.render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    </React.StrictMode>
  );
  reportWebVitals();
};

msalInstance.initialize().then(async () => {
  console.log('[MSAL] initialized');

  try {
    const result = await msalInstance.handleRedirectPromise();
    if (result) {
      console.log('[MSAL] redirect processed, account:', result.account?.username);
    } else {
      console.log('[MSAL] no redirect result (normal page load or already processed)');
    }
  } catch (error: any) {
    console.error('[MSAL] handleRedirectPromise error:', error);
    // Stale interaction state left by an interrupted popup/redirect (e.g. after a
    // deployment that changed the auth flow). Clear MSAL storage and reload once so
    // the user gets a clean session without needing a manual cache clear.
    const staleStateCodes = ['interaction_in_progress', 'state_not_found', 'unexpected_error'];
    if (staleStateCodes.includes(error?.errorCode)) {
      console.warn('[MSAL] Clearing stale interaction state and reloading...');
      await msalInstance.clearCache();
      globalThis.location.replace(globalThis.location.origin + '/');
      return;
    }
  }

  renderApp();
}).catch(error => {
  console.error('[MSAL] initialization failed:', error);
  // Still render so the user sees the login page rather than a blank screen.
  renderApp();
});
